// import API_KEY from "../../APIs/stock-data-api";
import sData from "./dummyStocks"

// const API_BASE_URL = 'https://cloud.iexapis.com/stable/stock';

async function fetchStockData(stockSymbol, flag) {
  // try {
  //   const response = await fetch(
  //     `${API_BASE_URL}/${stockSymbol}/quote?token=${API_KEY}`
  //   );

  //   if (!response.ok) {
  //     throw new Error('Failed to fetch stock data');
  //   }

  //   const data = await response.json();
  
    for(let i=0;i<10;i++){
      if(sData[i].symbol===stockSymbol){
        return  { 
          symbol: sData[i].symbol,
          company: sData[i].company,
          price: sData[i].price,
          change: sData[i].change,
          marketCap : sData[i].marketCap,
          previousClose : sData[i].previousClose,
          week52High : sData[i].week52High,
          week52Low : sData[i].week52Low,
          ytdChange : sData[i].ytdChange,
          peRatio : sData[i].peRatio,
          primaryExchange : sData[i].primaryExchange,
          iexClose : sData[i].iexClose,
          iexCloseTime : sData[i].iexCloseTime,
          currency : sData[i].currency
        };
      }
    }
  // } catch (error) {
  //   console.error('Error fetching stock data:', error);
  //   return null;
  // }
}

export default fetchStockData;
